import React from "react";
import { Box, Typography, IconButton, List, ListItem, ListItemText, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";
import XIcon from "@mui/icons-material/X";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const { t } = useTranslation();
const socialLinks = [
  { icon: <FaFacebook size={30} />, url: 'https://www.facebook.com/remora.tr/' },
  { icon: <XIcon sx={{ fontSize: 30 }} />, url: 'https://x.com/remora_co?s=21' },
  { icon: <FaInstagram size={30} />, url: 'https://www.instagram.com/remora.co/' },
  { icon: <BsYoutube size={30} />, url: 'https://www.youtube.com/channel/UCCPBKqowpW-yzEzw5I_z19w' },
  { icon: <AiFillLinkedin size={30} />, url: 'https://www.linkedin.com/company/remora-teknoloji/posts/?feedView=all' },
];

const pageLinks = [
  { name: t("pageLinks.home"), path: "/" },
  { name: t("pageLinks.about"), path: "/hakkimizda" },
  { name: t("pageLinks.products"), path: "/urunler" },
  { name: t("pageLinks.blog"), path: "/blog" },
  { name: t("pageLinks.news"), path: "/haberler" },
  { name: t("pageLinks.contact"), path: "/iletisim" },
];

const contactInfo = [
  { label: t("contact.email"), value: "info@remora.com.tr" },
  { label: t("contact.phone"), value: "0546 271 60 14" },
  { label: t("contact.rndAddress"), value: "İstasyon Mah, Güney Yanyol Cd. No:78, 41400 Gebze/Kocaeli" },
  { label: t("contact.officeAddress"), value: "Sanayi Mahallesi Teknopark Bulvarı No:1 / 4C İç Kapı No : 122, 34906 Pendik/İstanbul" },
];

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};


  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#005D85",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "white",
        py: 4,
      }}
    >
        
      {/* Sayfa Linkleri ve İletişim Bilgileri (Ortada) */}
      <Box sx={{ width: "80%", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 4 }}>
        {/* Sayfa Linkleri */}
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, width: "50%" }}>
          <List sx={{ textAlign: "center" }}>
            {pageLinks.map((link, index) => (
              <ListItem key={index} disablePadding>
                <ListItemText
                  primary={
                    <RouterLink
                      to={link.path}
                      onClick={scrollToTop}
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "bold",
                        transition: "color 0.3s ease",
                        "&:hover": { color: "#4DB5FF" },
                      }}
                    >
                      {link.name}
                    </RouterLink>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* İletişim Bilgileri */}
      
<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, width: "50%" }}>
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
    {contactInfo.map((info, index) => (
      <Box key={index} sx={{ color: "white", textAlign: "left", width: "100%" }}> {/* Text left align and full width */}
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{info.label}:</Typography>
        <Typography sx={{ fontSize: "14px" }}>{info.value}</Typography>
      </Box>
    ))}
  </Box>
</Box>

      </Box>

      
       {/* Daha belirgin çizgi */}
       <Divider sx={{ width: "80%", my: 3, borderWidth: "2px", borderColor: "#FFFFFF" }} />

      {/* Sosyal Medya Butonları */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 3 }}>
        {socialLinks.map((link, index) => (
          <IconButton
            key={index}
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "white",
              "&:hover": { color: "#4DB5FF", transform: "scale(1.1)" },
              transition: "color 0.3s ease, transform 0.3s ease",
            }}
          >
            {link.icon}
          </IconButton>
        ))}
      </Box>

      {/* Copyright Bilgisi */}
      <Typography variant="h6" sx={{ mt: 3 }}>
      {t("copyright", { year: new Date().getFullYear() })}
      </Typography>
    </Box>
  );
};

export default Footer;
